<template>
	<form class='form' @submit.prevent='formSubmit'>
		<h4>Предписание на группу актов</h4>
			<div class="row">
				<!-- <div class="col-md-1 col">№ письма</div>
				<div class="col-md-1 col">Дата письма</div> -->
				<div class="col-md-3 col">Федеральный округ</div>
                <div class="col-md-3 col">Субъект</div>
                <div class="col-md-2 col">Год размещения</div>
			</div>
            <div class="row">
				<!-- <div class="col-md-1 col">
                    <input type="text" class="form-control"/>
                </div>
				<div class="col-md-1 col">
                    <datepicker
                        v-model='letter_date'
						format='dd.MM.yyyy'>
                    </datepicker>
                </div> -->
				<div class="col-md-3 col">
                    <select class="form-control" v-model='fo_id' :disabled='!fo_list.length' @change='foChange'>
                        <option v-for='fo in fo_list' :value='fo.id' :key='fo.id'>
                            {{ fo.name }}
                        </option>
                    </select>
                </div>
                <div class="col-md-3 col">
                    <select class="form-control" v-model='region_id' :disabled='!regions_list.length' @change='regionChange'>
                        <option v-for='region in regions_list' :value='region.id' :key='region.id'>
                            {{ region.name }}
                        </option>
                    </select>
                </div>
                <div class="col-md-2 col">
                    <select class="form-control" v-model="year" @change='yearChange'>
                        <option :value="null"></option>
                        <option :value="2026">2026</option>
                        <option :value="2025">2025</option>
                        <option :value="2024">2024</option>
                        <option :value="2023">2023</option>
                        <option :value="2022">2022</option>
                        <option :value="2021">2021</option>
                        <option :value="2020">2020</option>
                        <option :value="2019">2019</option>
                        <option :value="2018">2018</option>
                        <option :value="2017">2017</option>
                    </select>
                </div>
			</div>
            <div class="row">
				<div class="col-md-8">
					<table class='documentsTable'>
						<thead>
							<tr>
								<th>Официальные документы</th>
								<th>Дата</th>
								<th>Номер</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Поступление акта ЛПО в ДЛХ по ФО*</td>
								<td><datepicker
									v-model='f_51'
									format='dd.MM.yyyy'
									:class='(!f_51 && selected_acts_ids.length) ? "field-error-warrant" : ""'
									:disabled='readonly || !selected_acts_ids.length'
									class='table-control'
								></datepicker></td>
								<td><input class="table-control form-control my-control" v-model='f_52' :disabled='readonly || !selected_acts_ids.length'></input></td>
							</tr>
							<tr>
								<td>Приказ проведения документарной проверки</td>
								<td><datepicker
									v-model='f_54'
									format='dd.MM.yyyy'
									:disabled='readonly || !selected_acts_ids.length'
									class='table-control'
								></datepicker></td>
								<td><input class="table-control form-control my-control" v-model='f_55' :disabled='readonly || !selected_acts_ids.length'></input></td>
							</tr>
							<tr>
								<td>Акт проведения документарной проверки**</td>
								<td><datepicker
									v-model='f_57'
									format='dd.MM.yyyy'
									:disabled='readonly || !selected_acts_ids.length'
									:class='(!f_57 && selected_acts_ids.length) ? "field-error-warrant-optional" : ""'
									class='table-control'
								></datepicker></td>
								<td><input class="table-control form-control my-control" v-model='f_58' :disabled='readonly || !selected_acts_ids.length'></input></td>
							</tr>
                            <tr>
								<td>
									<select class='table-control form-control my-control' v-model='f_71' :disabled='readonly || !selected_acts_ids.length'>
										<option v-for='item in official_docs' :value='item.id' :key='item.id' v-text='item.name'/>
									</select>
								</td>
								<td><datepicker
									v-model='f_72'
									format='dd.MM.yyyy'
									:disabled='readonly || !selected_acts_ids.length'
									class='table-control'
								></datepicker></td>
								<td><input class="table-control form-control my-control" v-model='f_73' :disabled='readonly || !selected_acts_ids.length'></input></td>
							</tr>
						</tbody>
					</table>
				</div>
            </div>
            <!-- <div class="row">
                <div class="col-md-8 text-center">
                    Нарушения НПА
                </div>
            </div> -->
            <hr>
            <div class="row">
                <div class="col-md-6 col text-left">
                    <button @click='printWarrant' class="btn btn-default medium-button" :disabled='!selected_acts_ids.length || (f_71 != 1 && f_71 != 2 && f_71 != 4)'>
                        Сформировать предписание
                    </button>

                    <button @click='printDocumentCheck' class="btn btn-default medium-button" :disabled='!selected_acts_ids.length'>
                        Сформировать акт документарной проверки
                    </button>

                    <dropdown text='Сохранить все акты как' class='medium-button' :disabled='submit_disabled || !selected_acts_ids.length || !f_51'>
                        <li><a href='#' @click='submit(1)'>Черновики</a></li>
                        <li><a href='#' @click='submit(0)'>Чистовики</a></li>
                    </dropdown>

                    <!-- <button @click='submit' class="btn btn-default small-button" :disabled='submit_disabled || !selected_acts_ids.length || !f_51 || !f_57'>
                        Сохранить всё
                    </button> -->

                    <button @click='showActsModal' class="btn btn-default medium-button" :disabled='!acts_nums_is_loaded'>
                        Добавить акт <i class='fa fa-spinner fa-spin' v-if='acts_nums_is_loading'></i>
                    </button>
                </div>
            </div>
            <div class="row" v-if='actsWithPositiveDecision.length'>
                <div class="col-md-12 col">
                    <div class="row">
                        <div class="col-md-12 col">
                            Акты с положительным решением
                            <table class="acts_table">
                                <thead>
                                    <tr>
                                        <th rowspan='2' width='20'></th>
                                        <th rowspan='2' class="form_td">№ акта</th>
                                        <th rowspan='2' class="form_td">Участковое лесничество</th>
                                        <th rowspan='2' class="form_td">Подлес-во</th>
                                        <th rowspan='2' class="form_td">Квартал</th>
                                        <th rowspan='2' class="form_td">Выдел</th>
                                        <th rowspan='2' class="form_td">S выдела</th>
                                        <th rowspan='2' class="form_td">Лп. Выдел</th>
                                        <th rowspan='2' class="form_td">S лп. выдела</th>
                                        <th rowspan='2' class="form_td">МЗЛ</th>
                                        <th rowspan='2' class="form_td">S МЗЛ</th>
                                        <!-- <th rowspan='2' class="form_td">Участки требующие проведения выездной проверки</th> -->
                                        <th colspan="5" class='colspan_td'>Соответствие сведений</th>
                                        <th rowspan='2' class="form_td">Решение ДЛХ по ФО</th>
                                        <!-- <th rowspan='2' class="form_td">Участки требующие проведения выездной проверки</th> -->
                                        <th rowspan='2' :width='scroll_width'></th>
                                    </tr>
                                    <tr>
                                        <th class="form_td" title='Соответствие сведений данным ГЛПМ'>свед. данным ГЛПМ</th>
                                        <th class="form_td" title='соответствия сведений таксационным характеристикам лесного участка'>свед. ТО</th>
                                        <th class="form_td" title='соответствие  мероприятий данным ГЛПМ'>мероприятий данным ГЛПМ</th>
                                        <th class="form_td" title='запрещение или ограничение законодательством РФ мероприятий'>законодательству РФ</th>
                                        <th class="form_td" title='недостоверность сведений санитарному и лесопатологическому состоянию лесов'>Недост.свед. Сан. Сост.</th>
                                    </tr>
                                </thead>
                            </table>
                            <div class="table_body_wrap">
                                <table class="acts_table content_table">
                                    <tbody>
                                        <tr v-for='act in actsWithPositiveDecision' :key='act.f_c'>
                                            <td :rowspan='act.count' width='20' v-if='act.flag' class='checkbox_wrapper'>
                                                <input type="checkbox" v-model='act.checked' @input='actCheckChange($event, act.f_p)'/>
                                            </td>
                                            <td :rowspan='act.count' v-if='act.flag'>{{ act.f_2 }}</td>
                                            <td :rowspan='act.count_lf' v-if='act.flag_lf'>{{ act.f_20 }}</td>
                                            <td :rowspan='act.count_sf' v-if='act.flag_sf'>{{ act.f_27 }}</td>
                                            <td>{{ act.f_17 }}</td>
                                            <td>{{ act.f_24 }}</td>
                                            <td>{{ act.f_21 }}</td>
                                            <td>{{ act.f_25 }}</td>
                                            <td>{{ act.f_23 }}</td>
                                            <td>{{ act.f_16 }}</td>
                                            <td>{{ act.f_22 }}</td>
                                            <!-- <td><input type="checkbox" v-model='act.f_91' disabled/></td> -->
                                            <td>
                                                <select class='form-control my-control table-control' v-model='act.f_76' :disabled='readonly' @change='updateViolations'>
                                                    <option value="2">Нет данных</option>
                                                    <option value="1">Соответствует</option>
                                                    <option value="0">Не соответствует</option>
                                                </select>
                                            </td>
                                            <td>
                                                <select class='form-control my-control table-control' v-model='act.f_77' :disabled='readonly' @change='updateViolations'>
                                                    <option value="2">Нет данных</option>
                                                    <option value="1">Соответствует</option>
                                                    <option value="0">Не соответствует</option>
                                                </select>
                                            </td>
                                            <td>
                                                <select class='form-control my-control table-control' v-model='act.f_78' :disabled='readonly' @change='updateViolations'>
                                                    <option value="2">Нет данных</option>
                                                    <option value="1">Соответствует</option>
                                                    <option value="0">Не соответствует</option>
                                                </select>
                                            </td>
                                            <td>
                                                <select class='form-control my-control table-control' v-model='act.f_79' :disabled='readonly' @change='updateViolations'>
                                                    <option value="2">Нет данных</option>
                                                    <option value="1">Соответствует</option>
                                                    <option value="0">Не соответствует</option>
                                                </select>
                                            </td>
                                            <td>
                                                <select class='form-control my-control table-control' v-model='act.f_80' :disabled='readonly' @change='updateViolations'>
                                                    <option value="2">Нет данных</option>
                                                    <option value="1">Соответствует</option>
                                                    <option value="0">Не соответствует</option>
                                                </select>
                                            </td>
                                            <td>
                                                <select class='form-control my-control table-control' v-model='act.f_81' @change='updateViolations'>
                                                    <option value="2">Нет данных</option>
                                                    <option value="1">Положительное</option>
                                                    <option value="0">Отрицательное</option>
                                                </select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="row buttons-row" v-if='checkedPositiveActs.length'>
                        <div class="col-md-6 col text-left">
                            Действия с выделенными: 
                            <button class="btn btn-default small-button" @click='checkedToNegative'>
                                Перевести в отрицательные
                            </button>
                            <button class="btn btn-default small-button" @click='deleteCheckedActsFromPositive'>
                                Удалить
                            </button>
                        </div>
                    </div>
                    <hr/>
                </div>
            </div>

            <div class="row" v-if='actsWithNegativeDecision.length'>
                <div class="col-md-12 col">
                    <div class="row">
                        <div class="col-md-12 col">
                            Акты с отрицательным решением
                            <table class="acts_table">
                                <thead>
                                    <tr>
                                        <th rowspan='2' width='20'></th>
                                        <th rowspan='2' class="form_td">№ акта</th>
                                        <th rowspan='2' class="form_td">Участковое лесничество</th>
                                        <th rowspan='2' class="form_td">Подлес-во</th>
                                        <th rowspan='2' class="form_td">Квартал</th>
                                        <th rowspan='2' class="form_td">Выдел</th>
                                        <th rowspan='2' class="form_td">S выдела</th>
                                        <th rowspan='2' class="form_td">Лп. Выдел</th>
                                        <th rowspan='2' class="form_td">S лп. выдела</th>
                                        <th rowspan='2' class="form_td">МЗЛ</th>
                                        <th rowspan='2' class="form_td">S МЗЛ</th>
                                        <!-- <th rowspan='2' class="form_td">Участки требующие проведения выездной проверки</th> -->
                                        <th colspan="5" class='colspan_td'>Соответствие сведений</th>
                                        <th rowspan='2' class="form_td">Решение ДЛХ по ФО</th>
                                        <th rowspan='2' class="form_td">Главная причина отмены акта</th>
                                        <th rowspan='2' class="form_td">Нарушения<br>НПА</th>
                                        <!-- <th rowspan='2' class="form_td">Участки требующие проведения выездной проверки</th> -->
                                        <th rowspan='2' :width='scroll_width'></th>
                                    </tr>
                                    <tr>
                                        <th class="form_td" title='Соответствие сведений данным ГЛПМ'>свед. данным ГЛПМ</th>
                                        <th class="form_td" title='соответствия сведений таксационным характеристикам лесного участка'>свед. ТО</th>
                                        <th class="form_td" title='соответствие  мероприятий данным ГЛПМ'>мероприятий данным ГЛПМ</th>
                                        <th class="form_td" title='запрещение или ограничение законодательством РФ мероприятий'>законодательству РФ</th>
                                        <th class="form_td" title='недостоверность сведений санитарному и лесопатологическому состоянию лесов'>Недост.свед. Сан. Сост.</th>
                                    </tr>
                                </thead>
                            </table>        
                            <div class="table_body_wrap">
                                <table class="acts_table content_table">
                                    <tbody>
                                        <tr v-for='act in actsWithNegativeDecision' :key='act.f_c'>
                                            <td :rowspan='act.count' width='20' v-if='act.flag' class='checkbox_wrapper'>
                                                <input type="checkbox" v-model='act.checked' @input='actCheckChange($event, act.f_p)'/>
                                            </td>
                                            <td :rowspan='act.count' v-if='act.flag'>{{ act.f_2 }}</td>
                                            <td :rowspan='act.count_lf' v-if='act.flag_lf'>{{ act.f_20 }}</td>
                                            <td :rowspan='act.count_sf' v-if='act.flag_sf'>{{ act.f_27 }}</td>
                                            <td>{{ act.f_17 }}</td>
                                            <td>{{ act.f_24 }}</td>
                                            <td>{{ act.f_21 }}</td>
                                            <td>{{ act.f_25 }}</td>
                                            <td>{{ act.f_23 }}</td>
                                            <td>{{ act.f_16 }}</td>
                                            <td>{{ act.f_22 }}</td>
                                            <!-- <td><input type="checkbox" v-model='act.f_91' disabled/></td> -->
                                            <td>
                                                <select class='form-control my-control table-control' v-model='act.f_76' :disabled='readonly' @change='updateViolations'>
                                                    <option value="2">Нет данных</option>
                                                    <option value="1">Соответствует</option>
                                                    <option value="0">Не соответствует</option>
                                                </select>
                                            </td>
                                            <td>
                                                <select class='form-control my-control table-control' v-model='act.f_77' :disabled='readonly' @change='updateViolations'>
                                                    <option value="2">Нет данных</option>
                                                    <option value="1">Соответствует</option>
                                                    <option value="0">Не соответствует</option>
                                                </select>
                                            </td>
                                            <td>
                                                <select class='form-control my-control table-control' v-model='act.f_78' :disabled='readonly' @change='updateViolations'>
                                                    <option value="2">Нет данных</option>
                                                    <option value="1">Соответствует</option>
                                                    <option value="0">Не соответствует</option>
                                                </select>
                                            </td>
                                            <td>
                                                <select class='form-control my-control table-control' v-model='act.f_79' :disabled='readonly' @change='updateViolations'>
                                                    <option value="2">Нет данных</option>
                                                    <option value="1">Соответствует</option>
                                                    <option value="0">Не соответствует</option>
                                                </select>
                                            </td>
                                            <td>
                                                <select class='form-control my-control table-control' v-model='act.f_80' :disabled='readonly' @change='updateViolations'>
                                                    <option value="2">Нет данных</option>
                                                    <option value="1">Соответствует</option>
                                                    <option value="0">Не соответствует</option>
                                                </select>
                                            </td>
                                            <td>
                                                <select class='form-control my-control table-control' v-model='act.f_81' @change='updateViolations'>
                                                    <option value="2">Нет данных</option>
                                                    <option value="1">Положительное</option>
                                                    <option value="0">Отрицательное</option>
                                                </select>
                                            </td>
                                            <td :rowspan='act.count' v-if='act.flag'>
                                                <select 
                                                    class="form-control my-control table-control"
                                                    :class='(act.errorDecisionReason || !act.f_125) ? "field-error-warrant" : ""'
                                                    :value='act.f_125' 
                                                    @change="handle125Change($event, act.f_p)"
                                                >
                                                    <option v-for="reason of decisions" :key="reason.id" :value="reason.id">
                                                        {{ reason.name }}
                                                    </option>
                                                </select>
                                            </td>
                                            <td :rowspan='act.count' v-if='act.flag' style='position: relative;'>
                                                <npa-violations 
                                                    @change='handleNpaChange($event, act.f_p)' 
                                                    :npa='getNpaForAct(act.f_p)' 
                                                    :act_num='act.f_2' 
                                                    :disabled='getNpaDisabledForAct(act.f_p)'
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="row buttons-row" v-if='checkedNegativeActs.length'>
                        <div class="col-md-6 col text-left">
                            Действия с выделенными: 
                            <button class="btn btn-default small-button" @click='checkedToPositive'>
                                Перевести в положительные
                            </button>
                            <button class="btn btn-default small-button" @click='deleteCheckedActsFromNegative'>
                                Удалить
                            </button>
                        </div>
                    </div>
                    
                    <hr/>
                </div>
            </div>

            <div class="row" v-if='actsWithoutDecision.length'>
                <div class="col-md-12 col">
                    <div class="row">
                        <div class="col-md-12 col">
                            Акты без решения
                            <table class="acts_table">
                                <thead>
                                    <tr>
                                        <th rowspan='2' width='20'></th>
                                        <th rowspan='2' class="form_td">№ акта</th>
                                        <th rowspan='2' class="form_td">Участковое лесничество</th>
                                        <th rowspan='2' class="form_td">Подлес-во</th>
                                        <th rowspan='2' class="form_td">Квартал</th>
                                        <th rowspan='2' class="form_td">Выдел</th>
                                        <th rowspan='2' class="form_td">S выдела</th>
                                        <th rowspan='2' class="form_td">Лп. Выдел</th>
                                        <th rowspan='2' class="form_td">S лп. выдела</th>
                                        <th rowspan='2' class="form_td">МЗЛ</th>
                                        <th rowspan='2' class="form_td">S МЗЛ</th>
                                        <!-- <th rowspan='2' class="form_td">Участки требующие проведения выездной проверки</th> -->
                                        <th colspan="5" class='colspan_td'>Соответствие сведений</th>
                                        <th rowspan='2' class="form_td">Решение ДЛХ по ФО</th>
                                        <!-- <th rowspan='2' class="form_td">Участки требующие проведения выездной проверки</th> -->
                                        <th rowspan='2' :width='scroll_width'></th>
                                    </tr>
                                    <tr>
                                        <th class="form_td" title='Соответствие сведений данным ГЛПМ'>свед. данным ГЛПМ</th>
                                        <th class="form_td" title='соответствия сведений таксационным характеристикам лесного участка'>свед. ТО</th>
                                        <th class="form_td" title='соответствие  мероприятий данным ГЛПМ'>мероприятий данным ГЛПМ</th>
                                        <th class="form_td" title='запрещение или ограничение законодательством РФ мероприятий'>законодательству РФ</th>
                                        <th class="form_td" title='недостоверность сведений санитарному и лесопатологическому состоянию лесов'>Недост.свед. Сан. Сост.</th>
                                    </tr>
                                </thead>
                            </table>        
                            <div class="table_body_wrap">
                                <table class="acts_table content_table">
                                    <tbody>
                                        <tr v-for='act in actsWithoutDecision' :key='act.f_c'>
                                            <td :rowspan='act.count' width='20' v-if='act.flag' class='checkbox_wrapper'>
                                                <input type="checkbox" v-model='act.checked' @input='actCheckChange($event, act.f_p)'/>
                                            </td>
                                            <td :rowspan='act.count' v-if='act.flag'>{{ act.f_2 }}</td>
                                            <td :rowspan='act.count_lf' v-if='act.flag_lf'>{{ act.f_20 }}</td>
                                            <td :rowspan='act.count_sf' v-if='act.flag_sf'>{{ act.f_27 }}</td>
                                            <td>{{ act.f_17 }}</td>
                                            <td>{{ act.f_24 }}</td>
                                            <td>{{ act.f_21 }}</td>
                                            <td>{{ act.f_25 }}</td>
                                            <td>{{ act.f_23 }}</td>
                                            <td>{{ act.f_16 }}</td>
                                            <td>{{ act.f_22 }}</td>
                                            <!-- <td><input type="checkbox" v-model='act.f_91' disabled/></td> -->
                                            <td>
                                                <select class='form-control my-control table-control' v-model='act.f_76' :disabled='readonly' @change='updateViolations'>
                                                    <option value="2">Нет данных</option>
                                                    <option value="1">Соответствует</option>
                                                    <option value="0">Не соответствует</option>
                                                </select>
                                            </td>
                                            <td>
                                                <select class='form-control my-control table-control' v-model='act.f_77' :disabled='readonly' @change='updateViolations'>
                                                    <option value="2">Нет данных</option>
                                                    <option value="1">Соответствует</option>
                                                    <option value="0">Не соответствует</option>
                                                </select>
                                            </td>
                                            <td>
                                                <select class='form-control my-control table-control' v-model='act.f_78' :disabled='readonly' @change='updateViolations'>
                                                    <option value="2">Нет данных</option>
                                                    <option value="1">Соответствует</option>
                                                    <option value="0">Не соответствует</option>
                                                </select>
                                            </td>
                                            <td>
                                                <select class='form-control my-control table-control' v-model='act.f_79' :disabled='readonly' @change='updateViolations'>
                                                    <option value="2">Нет данных</option>
                                                    <option value="1">Соответствует</option>
                                                    <option value="0">Не соответствует</option>
                                                </select>
                                            </td>
                                            <td>
                                                <select class='form-control my-control table-control' v-model='act.f_80' :disabled='readonly' @change='updateViolations'>
                                                    <option value="2">Нет данных</option>
                                                    <option value="1">Соответствует</option>
                                                    <option value="0">Не соответствует</option>
                                                </select>
                                            </td>
                                            <td>
                                                <select class='form-control my-control table-control' v-model='act.f_81' @change='updateViolations'>
                                                    <option value="2">Нет данных</option>
                                                    <option value="1">Положительное</option>
                                                    <option value="0">Отрицательное</option>
                                                </select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="row buttons-row" v-if='checkedNeutralActs.length'>
                        <div class="col-md-9 col text-left">
                            Действия с выделенными: 
                            <button class="btn btn-default small-button" @click='checkedToPositive(true)'>
                                Перевести в положительные
                            </button>
                            <button class="btn btn-default small-button" @click='checkedToNegative(true)'>
                                Перевести в отрицательные
                            </button>
                            <button class="btn btn-default small-button" @click='deleteCheckedActsFromNeutral'>
                                Удалить
                            </button>
                        </div>
                    </div>
                    
                    <hr/>
                </div>
            </div>

            <!-- <button @click='test'>test</button> -->

            <modal v-model="display_acts_modal" :backdrop='false' width="85%">
                <div slot="modal-header" class="modal-header">
                    <h4 class="modal-title">
                        <b>Добавление актов</b>
                    </h4>
                </div>
                
                <acts-nums-selector :acts_nums='acts_nums' @change='changeSearchIds' @search='findActs' :acts_is_loading='acts_is_loading'/>

                <div class="row acts_table_wrap">
                    <div class="col-md-12 col">
                        <table class="acts_search_table" :class='{loading: acts_is_loading}' v-if='found_acts.length || acts_is_loading'>
                            <thead>
                                <tr>
                                    <th>
                                        № акта
                                    </th>
                                    <th>
                                        Дата размещения
                                    </th>
                                    <th>
                                        ФО
                                    </th>
                                    <th>
                                        Субъект РФ
                                    </th>
                                    <th>
                                        Лесничество
                                    </th>
                                    <th>
                                        Уч. лесничество
                                    </th>
                                    <th>
                                        Подслесничество
                                    </th>
                                    <th>
                                        Квартал
                                    </th>
                                    <th>
                                        Выдел
                                    </th>
                                    <th>
                                        Л.п. выдел
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if='acts_is_loading' class="loading_row">
                                    <td colspan="10">
                                        <i class='fa fa-spinner fa-spin'></i>
                                    </td>
                                </tr>
                                <tr v-for='(act, index) in found_acts'
                                    v-else
                                    :key='act.id + index'
                                    :class='{"hovered": act.id == hovered_act_in_found, "selected": act.id == selected_act_in_found, "disabled": isActInBasket(act.id)}'
                                    @click='selectActInFound(act.id)' 
                                    @mouseover='mouseOverActInFound(act.id)'
                                    @mouseleave='hovered_act_in_found = 0'
                                >
                                    <td v-if='act.flag' :rowspan='act.count'>{{ act.num }}</td>
                                    <td v-if='act.flag' :rowspan='act.count'>{{ act.act_placement_date }}</td>
                                    <td v-if='act.flag' :rowspan='act.count'>{{ act.fo }}</td>
                                    <td v-if='act.flag' :rowspan='act.count'>{{ act.region }}</td>
                                    <td v-if='act.flag' :rowspan='act.count'>{{ act.forestry }}</td>
                                    <td v-if='act.flag_lf' :rowspan='act.count_lf'>{{ act.localforestry}}</td>
                                    <td v-if='act.flag_sf' :rowspan='act.count_sf'>{{ act.subforestry }}</td>
                                    <td>{{ act.area }}</td>
                                    <td>{{ act.section }}</td>
                                    <td>{{ act.section_lp }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div slot="modal-footer" class="modal-footer">
                    <button type="button" class="btn btn-default" @click='hideActsModal'>Отмена</button>				
                    <button type="button" class="btn btn-primary" :disabled='!selected_act_in_found || isActInBasket(selected_act_in_found)' @click='addActToBasket'>Добавить</button>
                    <button type="button" class="btn btn-primary" :disabled='!found_acts.length' @click='addAllActsToBasket'>Добавить все</button>
                </div>
            </modal>
    </form>
</template>

<script>
import { DB } from '../../constants'
import auth from '../../auth'
import { datepicker, modal, dropdown } from 'vue-strap'
import moment from 'moment'
import npaViolations from './fetch_data/npaViolations'
import actsNumsSelector from './fetch_data/actsNumsSelector'

const GET_FO = 'get_fo.php'
const GET_REGIONS = 'region_list.php'
const GET_ACTS_NUMS = 'get_acts_nums.php'
const GET_JOURNAL_FILTER = 'get_journal_filter.php'
const GET_WARRANT_LOCATIONS = 'get_warrant_locations.php'
const DOCS = 'get_official_docs.php'
const REASON = 'get_decision_reason.php'

const PRINT_WARRANT = 'warrant_report.php'
const PRINT_DOCUMENT_CHECK = 'document_check_report.php'

const UPDATE_JSON = 'update_json.php'

import '../../lib/css/fontawesome-all.min.css'

export default {
    name: 'warrantGroupForm',
    data: function () {
        return {
            scroll_width: 17,
            letter_num: '',
            letter_date: moment().format('DD.MM.YYYY'),
            fo_list: [],
            fo_id: 0,
            regions_list: [],
            region_id: 0,
            year: null,
            display_acts_modal: false,

            acts_nums_is_loading: false,
            acts_is_loading: false,

            selected_acts_ids: [],
            warrant_locations: [],

            acts_nums_is_loaded: false,
            act_num_to_search: '',
            acts_nums: [],
            act_placement_date: '',
            display_nums_hint: false,
            //similar_nums: [],
            found_acts: [],
            official_docs: [],
            hovered_act_in_found: false,
            selected_act_in_found: false,

            readonly: false,
            submit_disabled: false,

            f_51: '',
            f_52: '',

            f_54: '',
            f_55: '',
            
            f_57: '',
            f_58: '',

            f_71: '',
            f_72: '',
            f_73: '',

            f_92: [],

            f_87: null,

            decisions: [],
            errorDecisionReason: false
        }
    },
    components: {
        datepicker, modal, npaViolations, actsNumsSelector, dropdown
    },
    computed: {
        actsWithPositiveDecision () {
            return this.warrant_locations.filter(e => {
                return e.main_decision == 1 || e.main_decision == 't'
            })
        },
        actsWithNegativeDecision () {
            return this.warrant_locations.filter(e => {
                return e.main_decision == 0 || e.main_decision == 'f'
            })
        },
        actsWithoutDecision () {
            return this.warrant_locations.filter(e => {
                return e.main_decision == 2 || e.main_decision === null
            })
        },
        checkedPositiveActs () {
            return this.actsWithPositiveDecision.filter(e => {
                return e.checked
            })
        },
        checkedNegativeActs () {
            return this.actsWithNegativeDecision.filter(e => {
                return e.checked
            })
        },
        checkedNeutralActs () {
            return this.actsWithoutDecision.filter(e => {
                return e.checked
            })
        },
        npaDisabled () {
            return !this.actsWithNegativeDecision.some(e => {
                return e.f_79 == 0
            })
        }
    },
    methods: {
        formSubmit () {
        },
        updateViolations () {
            this.checkF125Field()
        },
        checkedToNegative (neutralActs = false) {
            const clone = this.warrant_locations.slice()
            for(let i in clone) {
                if(clone[i].checked) {
                    if((neutralActs !== true) || (neutralActs === true && clone[i].main_decision == 2)) {
                        clone[i].main_decision = 0
                        //clone[i].f_81 = 0
                        clone[i].checked = false
                    }
                }
            }
            this.warrant_locations = clone
            this.checkF125Field()
        },
        checkedToPositive (neutralActs = false) {
            const clone = this.warrant_locations.slice()
            for(let i in clone) {
                if(clone[i].checked) {
                    if((neutralActs !== true) || (neutralActs === true && clone[i].main_decision == 2)) {
                        clone[i].main_decision = 1
                        clone[i].f_125 = null
                        //clone[i].f_81 = 1
                        clone[i].checked = false
                    }
                }
            }
            this.warrant_locations = clone
        },
        deleteCheckedActsFromNegative () {
            let ids_to_delete = {}
            for(let location of this.checkedNegativeActs) {
                ids_to_delete[location.f_p] = true
            }
            ids_to_delete = Object.keys(ids_to_delete)
            this.selected_acts_ids = this.selected_acts_ids.filter(e => !ids_to_delete.includes(e))
            this.warrant_locations = this.warrant_locations.filter(e => !ids_to_delete.includes(e.f_p))
        },
        deleteCheckedActsFromPositive () {
            let ids_to_delete = {}
            for(let location of this.checkedPositiveActs) {
                ids_to_delete[location.f_p] = true
            }
            ids_to_delete = Object.keys(ids_to_delete)
            this.selected_acts_ids = this.selected_acts_ids.filter(e => !ids_to_delete.includes(e))
            this.warrant_locations = this.warrant_locations.filter(e => !ids_to_delete.includes(e.f_p))
        },
        deleteCheckedActsFromNeutral () {
            let ids_to_delete = {}
            for(let location of this.checkedNeutralActs) {
                ids_to_delete[location.f_p] = true
            }
            ids_to_delete = Object.keys(ids_to_delete)
            this.selected_acts_ids = this.selected_acts_ids.filter(e => !ids_to_delete.includes(e))
            this.warrant_locations = this.warrant_locations.filter(e => !ids_to_delete.includes(e.f_p))
        },
        getNpaDisabledForAct (act_id) {
            const found = this.actsWithNegativeDecision.filter(e => e.f_p == act_id)
            if(found) {
                //console.warn(act_id, !found.some(e => e.f_79 == 0))
                return !found.some(e => e.f_79 == 0)
            }
            return true
        },
        getNpaForAct (act_id) {
            const act_info = this.f_92.filter(e => e.id == act_id)
            if(act_info && act_info[0])
                return act_info[0].npa
            else 
                return []

            //return act_info ? act_info[0].npa : []
        },
        actCheckChange (e, act_id) {
            const checkbox_state = e.target.checked
            const clone = this.warrant_locations.slice()

            for(let i in clone) {
                if(clone[i].f_p == act_id) {
                    clone[i].checked = checkbox_state
                }
            }
            this.warrant_locations = clone
        },
        idToBoolean (id) {
            if(id != '2') {
                return id == '1'
            } else
                return null
        },
        printWarrant(){
            const ids = this.selected_acts_ids.join(',')
            window.location.href = DB + PRINT_WARRANT + '?ids=' + ids + '&type=' + this.f_71 + '&fo=' + this.fo_id
        },
        printDocumentCheck(){
            const ids = this.selected_acts_ids.join(',')
            window.location.href = DB + PRINT_DOCUMENT_CHECK + '?ids=' + ids + '&date=' + this.f_57 + '&num=' + this.f_58 + '&fo=' + this.fo_id + '&region=' + this.region_id
        },
        submit (f_75) {
            if(document.querySelector('.field-error-warrant') !== null) {
                alert('Часть полей содержит некорректные данные. Сохранение невозможно')
                return;
            }

            if(document.querySelector('.field-error-warrant-optional') !== null) {
                const answer = confirm('Часть полей может содержать некорректную информацию. Вы уверены, что хотите сохранить?')
                if(!answer)
                    return;
			}
            this.submit_disabled = true          

            let obj = []
            let counter = 0
            for(let act_id of this.selected_acts_ids) {
                obj.push({})
                obj[counter].tab_id = 1
                obj[counter].f_v = {}
                obj[counter].f_v.f_c = act_id
                
                obj[counter].f_v.f_51 = this.f_51
                obj[counter].f_v.f_52 = this.f_52

                if(this.f_54)
                    obj[counter].f_v.f_54 = this.f_54
                obj[counter].f_v.f_55 = this.f_55

                obj[counter].f_v.f_57 = this.f_57 || null
                obj[counter].f_v.f_58 = this.f_58

                if(this.isActIsPositive(act_id)) {
                    obj[counter].f_v.f_71 = null
                    obj[counter].f_v.f_73 = null
                    obj[counter].f_v.f_72 = null   
                } else if(this.isActIsNegative(act_id)) {
                    obj[counter].f_v.f_71 = this.f_71
                    if(this.f_72)
                        obj[counter].f_v.f_72 = this.f_72
                    obj[counter].f_v.f_73 = this.f_73
                }
                
                obj[counter].f_v.f_75 = f_75

                obj[counter].f_v.f_87 = auth.user.id 

                const found_npa = this.f_92.find(e => e.id == act_id)
                if(found_npa && !this.getNpaDisabledForAct(act_id))
                   obj[counter].f_v.f_92 = '{' + found_npa.npa.join(',') + '}'

                if(this.isActIsPositive(act_id))
                    obj[counter].f_v.f_69 = 1
                else if(this.isActIsNegative(act_id))
                    obj[counter].f_v.f_69 = 0

                obj[counter].f_v.f_125 = this.warrant_locations.find(e => e.f_p == act_id).f_125 || null

                counter++
            }

            for(let location of this.warrant_locations) {
                obj.push({})
                obj[counter].tab_id = 2
                obj[counter].f_v = {}
                obj[counter].f_v.f_c = location.f_c

                obj[counter].f_v.f_76 = this.idToBoolean(location.f_76)
                obj[counter].f_v.f_77 = this.idToBoolean(location.f_77)
                obj[counter].f_v.f_78 = this.idToBoolean(location.f_78)
                obj[counter].f_v.f_79 = this.idToBoolean(location.f_79)
                obj[counter].f_v.f_80 = this.idToBoolean(location.f_80)
                obj[counter].f_v.f_81 = this.idToBoolean(location.f_81)

                counter++
            }

            let form = new FormData()
            form.append('json', JSON.stringify(obj))

            fetch(DB + UPDATE_JSON, {
                credentials: 'include',
                method: 'post',
                body: form
            })
            .then(result => result.json())
            .then(result => {
                if(result[0].code === '0') {
                    alert('Предписание на группу актов сохранено')

                    /*if(this.$parent.lastJournalURL)
                        router.replace(this.$parent.lastJournalURL)
                    else
                        router.replace('/main')*/
                }
                else {
                    alert(result[0].name)
                }
                this.submit_disabled = false
            })
            .catch(err => console.log(err))
        },
        handle125Change(event, act_id) {
            for(let i in this.warrant_locations) {
                if(this.warrant_locations[i].f_p == act_id) {
                    this.warrant_locations[i].f_125 = event.target.value
                }
            }
            this.checkF125Field()
        },
        checkF125Field() {
            const locations = []
            for(let loc of this.warrant_locations) {
                for(let i = 76; i <= 80; i++) {
                    if(loc[`f_${i}`] == 0) {
                        if(!locations[loc.f_p]) {
                            locations[loc.f_p] = {}
                        }
                        locations[loc.f_p][i] = true
                    }
                }
            }

            for(let loc_id in this.warrant_locations) {
                const act_id = this.warrant_locations[loc_id].f_p
                if(!this.warrant_locations[loc_id].f_125)
                    this.warrant_locations[loc_id].errorDecisionReason = true
                if(this.warrant_locations[loc_id].f_125 == 1)
                    this.warrant_locations[loc_id].errorDecisionReason = (locations[act_id] ? !locations[act_id][79] : true)
                if(this.warrant_locations[loc_id].f_125 == 2)
                    this.warrant_locations[loc_id].errorDecisionReason = (locations[act_id] ? !locations[act_id][78] : true)
                if(this.warrant_locations[loc_id].f_125 == 3)
                    this.warrant_locations[loc_id].errorDecisionReason = (locations[act_id] ? !locations[act_id][76] : true)
                if(this.warrant_locations[loc_id].f_125 == 4)
                    this.warrant_locations[loc_id].errorDecisionReason = (locations[act_id] ? !locations[act_id][77] : true)
            }
        },
        test () {
            console.warn(this.warrant_locations)
            console.warn(this.actsWithPositiveDecision)
            console.warn(this.actsWithNegativeDecision)
            /*console.warn(this.actsWithPositiveDecision.filter(e => {
                return e.checked
            }))
            console.warn(this.checkedPositiveActs)*/
            //console.warn(this.actsWithPositiveDecision)
        },
        hideActsModal () {
            this.display_acts_modal = false
            setTimeout(() => {
                this.hovered_act_in_found = false
                this.selected_act_in_found = false
                this.act_num_to_search = ''
                this.display_nums_hint = false
                this.similar_nums = []
                this.found_acts = []
            }, 300)
        },
        isActInBasket (act_id) {
            return this.selected_acts_ids.includes(act_id)
        },
        isActIsPositive (act_id) {
            return this.actsWithPositiveDecision.filter(e => e.f_p == act_id).length > 0
        },
        isActIsNegative (act_id) {
            return this.actsWithNegativeDecision.filter(e => e.f_p == act_id).length > 0
        },
        addAllActsToBasket() {
            this.selected_acts_ids = [... new Set(this.found_acts.map(e => e.id))]
            this.addActToBasket(false)
        },
        addActToBasket (add_id_to_selected = true) {
            if(add_id_to_selected)
                this.selected_acts_ids.push(this.selected_act_in_found)
            
            const joined_ids = '{' + this.selected_acts_ids.join(',') + '}'
            fetch(`${DB}${GET_WARRANT_LOCATIONS}?ids=${joined_ids}`, {credentials: 'include'})
            .then(res => res.json())
            .then(json => {
                const temp_lines = []
                const length = json.length

                let prev_id = -1
                let prev_localforestry_id = -1
                let prev_subforestry_id = -1
                    
                for (let i = 0; i < length; i++) {
                    let location = {}

                    let start_fo = i
                    while (i > 0 && json[start_fo - 1].f_p === json[i].f_p && start_fo > 1) {
                        start_fo--
                    }

                    let curr = start_fo
                    while (curr < json.length && json[curr].f_p === json[start_fo].f_p ) {
                        curr++
                    }
                    location.count = curr - start_fo

                    if (json[i].f_p === prev_id) {
                        location.flag = false
                    }
                    else {
                        location.flag = true
                    }

                    let start_lf = i
                    while (i > 0 && json[start_lf - 1].f_20 === json[i].f_20 && start_lf > 1 && json[start_lf - 1].f_p === json[i].f_p) {
                        start_lf--
                    }

                    let curr_lf = start_lf
                    while (curr_lf < json.length && json[curr_lf].f_p === json[start_lf].f_p && json[curr_lf].f_20 === json[i].f_20) {
                        curr_lf++
                    }
                    location.count_lf = curr_lf - start_lf

                    if (json[i].f_p === prev_id && prev_localforestry_id === json[i].f_20) {
                        location.flag_lf = false
                    }
                    else {
                        location.flag_lf = true
                    }

                    ////////////////////////
                    let start_sf = i
                    while (i > 0 && json[start_sf - 1].f_27 === json[i].f_27 && start_sf > 1 && json[start_sf - 1].f_p === json[i].f_p) {
                        start_sf--
                    }

                    let curr_sf = start_sf
                    while (curr_sf < json.length && json[curr_sf].f_p === json[start_sf].f_p && json[curr_sf].f_27 === json[i].f_27) {
                        curr_sf++
                    }
                    location.count_sf = curr_sf - start_sf

                    if (json[i].f_p === prev_id && prev_subforestry_id === json[i].f_27) {
                        location.flag_sf = false
                    }
                    else {
                        location.flag_sf = true
                    }

                    prev_id = json[i].f_p
                    prev_localforestry_id = json[i].f_20
                    prev_subforestry_id = json[i].f_27

                    location = Object.assign(location, json[i])

                    if(!this.f_92.filter(e => e.id == json[i].f_p).length && json[i].f_92) {
                        this.f_92.push({
                            id: json[i].f_p,
                            npa: json[i].f_92.slice(1,-1).split(',')
                        })
                    }
                    
                    temp_lines.push(location)
                }
                //

                for(let i in temp_lines) {
                    for (let j = 76; j <= 80; j++) {
						temp_lines[i][`f_${j}`] = temp_lines[i][`f_${j}`] ? ((temp_lines[i][`f_${j}`] === 't') ? 1 : 0) : 2
                    }
                    if(temp_lines[i]['f_69']) 
                        temp_lines[i]['f_81'] = (temp_lines[i]['f_69'] === 't') ? 1 : 0
                    else
                        temp_lines[i]['f_81'] = temp_lines[i]['f_41'] ? ((temp_lines[i]['f_41'] === 't') ? 1 : 0) : 2

                    temp_lines[i].main_decision = temp_lines[i]['f_81']
                        
                    temp_lines[i]['f_91'] = temp_lines[i]['f_91'] ? ((temp_lines[i]['f_91'] === 't') ? true : false) : false
                }

                this.warrant_locations = temp_lines
            })
        },
        
        mouseOverActInFound (act_id) {
            this.hovered_act_in_found = act_id
        },
        selectActInFound (act_id) {
            this.selected_act_in_found = act_id
        },
        changeSearchIds (data) {
            //console.warn(data)
            this.act_placement_date = data.date
            this.act_num_to_search = data.nums
        },
        findActs () {
            this.acts_is_loading = true
            this.selected_act_in_found = false
            const act_num_to_search_quoted = this.act_num_to_search.map(e => "'" + e + "'")

            let filter = `(fo_id = ${this.fo_id} and region_id = ${this.region_id}`
            if(this.act_num_to_search.length)
                filter += ` and num in (${act_num_to_search_quoted.join(',')})`
            if(this.year) 
                filter += ` and act_placement_date >= '01.01.${this.year}' and act_placement_date <= '31.12.${this.year}'`
            if(this.act_placement_date)
                filter += ` and act_placement_date = '${this.act_placement_date}'`
            filter += ')'            

            fetch(`${DB}${GET_JOURNAL_FILTER}?filter=${filter}&start=1&rows=9999`, {credentials: 'include'})
            .then(res => res.json())
            .then(res => {
                this.acts_is_loading = false
                const temp_lines = []
                const length = res.length - 1

                let prev_id = -1
				let prev_localforestry_id = -1
                let prev_subforestry_id = -1
                    
                for (let i = 0; i < length; i++) {
                    let act = {}

                    let start_fo = i
                    while (i > 0 && res[start_fo - 1].act_id === res[i].act_id && start_fo > 1) {
                        start_fo--
                    }

                    let curr = start_fo
                    while (curr < res.length && res[curr].act_id === res[start_fo].act_id ) {
                        curr++
                    }
                    act.count = curr - start_fo

                    if (res[i].act_id === prev_id) {
                        act.flag = false
                    }
                    else {
                        act.flag = true
                    }
                    //////////////////

                    let start_lf = i
                    while (i > 0 && res[start_lf - 1].localforestry_id === res[i].localforestry_id && start_lf > 1 && res[start_lf - 1].act_id === res[i].act_id) {
                        start_lf--
                    }

                    let curr_lf = start_lf
                    while (curr_lf < res.length && res[curr_lf].act_id === res[start_lf].act_id && res[curr_lf].localforestry_id === res[i].localforestry_id) {
                        curr_lf++
                    }
                    act.count_lf = curr_lf - start_lf

                    if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
                        act.flag_lf = false
                    }
                    else {
                        act.flag_lf = true
                    }

                    ////////////////////////
                    let start_sf = i
                    while (i > 0 && res[start_sf - 1].localforestry_id === res[i].localforestry_id && start_sf > 1 && res[start_sf - 1].act_id === res[i].act_id) {
                        start_sf--
                    }

                    let curr_sf = start_sf
                    while (curr_sf < res.length && res[curr_sf].act_id === res[start_sf].act_id && res[curr_sf].localforestry_id === res[i].localforestry_id) {
                        curr_sf++
                    }
                    act.count_sf = curr_sf - start_sf

                    if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
                        act.flag_sf = false
                    }
                    else {
                        act.flag_sf = true
                    }

                    prev_id = res[i].act_id
                    prev_localforestry_id = res[i].localforestry_id
                    prev_subforestry_id = res[i].subforestry_id

                    act.id = res[i].act_id
                    act.num = res[i].num
                    act.act_placement_date = res[i].act_placement_date ? moment(res[i].act_placement_date, 'YYYY-MM-DD').format('DD.MM.YYYY') : ''
                    //act.url = res[i].url
                    act.fo = res[i].fo
                    act.region = res[i].region
                    act.forestry = res[i].forestry
                    act.localforestry = res[i].localforestry
                    act.subforestry = res[i].subforestry
                    act.area = res[i].area
                    act.section = res[i].section
                    act.section_lp = res[i].section_lp
                    //act.conclusion_date = res[i].conclusion_date ? moment(res[i].conclusion_date, 'YYYY-MM-DD').format('DD.MM.YYYY') : '';
                    //act.conclusion_num = res[i].conclusion_num;
                    //act.selected = false
                    
                    temp_lines.push(act)
                }

                this.found_acts = temp_lines
                this.found_acts.length
            })
        },     
        showActsModal () {
            this.display_acts_modal = true
        },
        loadOfficialDocs () {
            fetch(`${DB}${DOCS}`, {
                credentials: 'include'
            })
            .then(data => data.json())
            .then(data => {
                this.official_docs = data
                this.f_71 = this.official_docs[0].id
            })
        },
        loadFoList () {
            fetch(`${DB}${GET_FO}`)
            .then(res => res.json())
            .then(json => {
                this.fo_list = json
            })
        },
        loadRegionsList (fo_id) {
            fetch(`${DB}${GET_REGIONS}?id=${fo_id}`, {credentials: 'include'})
            .then(res => res.json())
            .then(json => {
                this.regions_list = json
            })
        },
        foChange () {
            if(this.fo_id) {
                this.region_id = 0
                this.loadRegionsList(this.fo_id)
            }      
        },
        regionChange () {
            if(this.region_id) {
                this.acts_nums_is_loaded = false
                this.getActsNums()
            }
        },
        yearChange () {
            if(this.year && this.region_id) {
                this.acts_nums_is_loaded = false
                this.getActsNums()
            }
        },
        getActsNums () {
            this.acts_nums_is_loading = true
            this.selected_act_in_found = false
            let filter = `(fo_id = ${this.fo_id} and region_id = ${this.region_id}`
            if(this.year) 
                filter += ` and act_placement_date >= '01.01.${this.year}' and act_placement_date <= '31.12.${this.year}'`
            filter += ')'

            fetch(`${DB}${GET_ACTS_NUMS}?filter=${filter}`)
            .then(res => res.json())
            .then(json => {
                this.acts_nums_is_loading = false
                this.acts_nums = json || []
                this.acts_nums_is_loaded = true
            })
        },
        handleNpaChange (data, act_id) {
            let f = false
            for(let i in this.f_92) {
                if(this.f_92[i].id == act_id) {
                    this.f_92[i].npa = data
                    f = true
                }
            }
            if(!f) {
                this.f_92.push({
                    id: act_id,
                    npa: data
                })
            }
            //console.warn(this.f_92)
            //this.f_92 = ids
        },
        loadDecisions() {
            fetch(DB + REASON, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				this.decisions = res
			})
        }
    },
    mounted () {
        this.loadFoList()
        this.loadOfficialDocs()
        this.loadDecisions()
    },
    beforeDestroy() {}
}
</script>

<style>
    button.dropdown-toggle[disabled],
    button.dropdown-toggle[disabled]:hover {
        background: #ccc;
    }

    .field-error-warrant,
    .field-error-warrant-optional,
    .field-error-warrant > input,
    .field-error-warrant-optional > input {
        background-color: #ffd5d5 !important;
    }

    select.field-error-warrant option {
        background-color: #fff !important;
    }

    select {
        padding: 0 !important;
    }
    
    .small-button {
        padding: 2px 12px; 
        height: 24px; 
        line-height: 12px !important;
    }

    .medium-button > button {
        height: 30px;
        line-height: 15px;
    }
</style>

<style scoped>
    .medium-button,
    .medium-button > button {
        height: 30px;
        line-height: 15px;
    }

    input[type="text"] {
        height: 24px !important;
    }

    .acts_search_table {
        width: 100%;
        margin-top: 10px;
        table-layout: fixed;
        border:1px solid #000;
    }

    .acts_search_table th {
        text-align: center;
    }

    .acts_search_table td {
        padding: 4px 6px;
    }

    .acts_search_table tbody tr.hovered {
        cursor: pointer;
        background: #daf2ff;
    }

    .acts_search_table tbody tr.selected {
        background-color: skyblue;
    }

    .acts_search_table tbody tr.disabled {
        background-color: #c0c0c0;
    }

    .acts_search_table tbody tr.loading_row {
        height: 100px;
    }

    .acts_search_table tbody tr.loading_row i {
        font-size: 30px;
    }

    .acts_search_table tbody tr.loading_row * {
        border: none;
    }

    .acts_search_table.loading {
        opacity: 0.5;
    }

    .acts_search_table * {
        border:1px solid #000;
        word-break: break-all;
    }

    .acts_table {
        table-layout: fixed;
        width: 100%;
    }

    .acts_table *,
    .acts_table select {
        font-size: 9px;
        border: 1px solid #000;
        padding: 4px;
        text-align: center;
        word-break: break-all;
    }

    .content_table tbody,
    .content_table tbody:first-child * {
        border-top: none;
    }
    
    .content_table td {
        padding: 0;
        background: #eee;
    }

    .content_table tr td.checkbox_wrapper {
        background: #fff;
    }

    .content_table select {
        border: none;
    }

    .acts_table_wrap {
        max-height: 70vh;
        overflow-y: auto;
    }

    .table_body_wrap {
        height: 300px;
        overflow-y: scroll;
    }

    .text-left {
        text-align: left !important;
    }

    .buttons-row {
        margin: 20px 0 0 0;
    }

    .documentsTable {
        margin-top: 15px;
    }
</style>


// WEBPACK FOOTER //
// WarrantGroupForm.vue?070ddd8a